import { FormBuilder, FormGroup } from "@angular/forms";
import { validateAgendaHorarios, DIAS } from "./agenda-validators";

export function buildAgendaFormGroup(fb: FormBuilder): FormGroup {
  const controls: { [key: string]: any[] } = {};
  for (const dia of DIAS) {
    controls[`${dia}Desde`]  = [""];
    controls[`${dia}Hasta`]  = [""];
    controls[`${dia}Desde2`] = [""];
    controls[`${dia}Hasta2`] = [""];
  }
  return fb.group(controls, { validators: [validateAgendaHorarios] });
}

function toHHmm(value: any): string {
  if (!value || typeof value !== "string") return "";
  return value.length >= 5 ? value.substring(0, 5) : value;
}

export function patchAgendaFormGroup(group: FormGroup, agenda: any): void {
  if (!agenda) return;
  const patch: { [key: string]: string } = {};
  for (const dia of DIAS) {
    patch[`${dia}Desde`]  = toHHmm(agenda[`${dia}_desde`]);
    patch[`${dia}Hasta`]  = toHHmm(agenda[`${dia}_hasta`]);
    patch[`${dia}Desde2`] = toHHmm(agenda[`${dia}_desde_2`]);
    patch[`${dia}Hasta2`] = toHHmm(agenda[`${dia}_hasta_2`]);
  }
  group.patchValue(patch);
}

export function agendaFormGroupToPayload(group: FormGroup): { [key: string]: string | null } {
  const payload: { [key: string]: string | null } = {};
  for (const dia of DIAS) {
    payload[`${dia}_desde`]   = group.get(`${dia}Desde`)?.value  || null;
    payload[`${dia}_hasta`]   = group.get(`${dia}Hasta`)?.value  || null;
    payload[`${dia}_desde_2`] = group.get(`${dia}Desde2`)?.value || null;
    payload[`${dia}_hasta_2`] = group.get(`${dia}Hasta2`)?.value || null;
  }
  return payload;
}
